import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import "./Slider.scss"

export default class Slider extends Component {
    constructor() {
        super();
        this.state = {
            Selected: {}
        }
    }
    shouldComponentUpdate(props) {
        return false;
    }
    componentDidMount() {
        // window.dispatchEvent(new Event("resize"));
        let event;
        if (typeof (Event) === 'function') {
            event = new Event('resize');
        } else {
            event = document.createEvent('Event');
            event.initEvent('resize', true, true);
        }
        window.dispatchEvent(event);
        this.props.setOwlRef ? this.props.setOwlRef(this.owl) : null;
        const container = document.querySelector(".owl-stage");
        container.addEventListener("click", (e) =>{
            if(e.target && e.target.className.indexOf("image") > -1) {
                const index = e.target.className.substring(e.target.className.lastIndexOf("-") + 1, e.target.className.length);
                this.owl.to(parseInt(index) - 1, 600);
                
            }  
            else if(e.target.className.indexOf("inner-title") > -1){
                this.owl.to(0, 600);
            }
        });

    }
    componentWillReceiveProps(newProps) {
        this.setState({
            Selected: newProps.Selected
        })
    }
    render() {
        return (
            <OwlCarousel
                className={`owl-theme`}
                // startPosition={"#item1"}
                margin={this.props.margin}
                nav={true}
                navSpeed={this.props.navSpeed}
                lazyLoad={true}
                dots={false}
                autoWidth={true}
                responsiveClass={true}
                loop={true}
                center={this.props.center}
                ref={(owl) => this.owl = owl}
                navText={["", ""]}
                onChanged={this.props.setNavBar ? this.props.setNavBar : (e) => { }}
                navContainerClass="controller"
                navClass={["arrow right", "arrow left"]}
                responsive={this.props.responsive ? this.props.responsive : {
                    0: {
                        items: 3,
                        slideBy: 1,
                        autoWidth: true,
                        rtl: true,
                        nav: true,
                        margin: 20,
                        center: true
                    },
                    1024: {
                        items: 3,
                        slideBy: 1,
                        autoWidth: true,
                        rtl: true,
                        nav: true,
                        center: this.props.center
                    }
                }}
            >
                {this.props.children}
            </OwlCarousel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Slider/Slider.jsx